import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import { Button } from '@sololearnorg/sol';
import s from './AIChatPlaygroundMessage.scss';
import {
	ConversationRole, Message, MessagePart, MessagePartType,
} from '../../aIChatPlaygroundInterface';
import { AIChatPlaygroundTextMessagePart } from './TextMessagePart/AIChatPlaygroundTextMessagePart';
import { AIChatPlaygroundImageMessagePart } from './ImageMessagePart/AIChatPlaygroundImageMessagePart';
import { Container, i18n } from '../../../../symphony';
import { aIChatPlaygroundContext } from '../../aIChatPlaygroundConstants';
import { AIChatPlaygroundService } from '../../services/AIChatPlaygroundService';

interface IAIChatPlaygroundMessageProps {
	message: Message;
	index?: number;
}

export const AIChatPlaygroundMessage = ({ message, index }: IAIChatPlaygroundMessageProps) => {
	useStyles(s);
	const { retryErrorMessage } = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);

	const getMessagePartComponent = (part: MessagePart) => {
		switch (part.type) {
			case MessagePartType.Text:
				return (
					<AIChatPlaygroundTextMessagePart
						key={part.type + index}
						index={index}
						content={part.content}
						role={message.role}
					/>
				);

			case MessagePartType.Image:
				return <AIChatPlaygroundImageMessagePart key={part.type + index} content={part.content} />;

			default:
				return null;
		}
	};

	return (
		<div className={classNames('ai-chat-playground-message', message.hasError && 'error', message.role === ConversationRole.Assistant && 'assistant')}>
			{
				message?.parts?.map((part) => getMessagePartComponent(part))
			}
			{
				message.hasError
				&& (
					<div className="ai-chat-playground-message__retry-button-container">
						<Button
							onClick={retryErrorMessage}
							buttonType="secondary"
						>
							{i18n.t('ai-chat.error.from-ai.cta')}
						</Button>
					</div>
				)
			}
		</div>
	);
};
